function initializeReference(){

    window.CountdownBannerTimers = window.CountdownBannerTimers || {};

    (function () {
      var sectionId = 'sections--20177149853835__anouncment_timer_AXPiaM';
      var timerId = 'countdown-' + sectionId;
      var hoursId = 'hh-' + sectionId;
      var minutesId = 'mm-' + sectionId;
      var secondsId = 'ss-' + sectionId;

      function getTimerElements() {
        return {
          timer: document.getElementById(timerId),
          hours: document.getElementById(hoursId),
          minutes: document.getElementById(minutesId),
          seconds: document.getElementById(secondsId)
        };
      }

      function toInt(value, fallback) {
        var parsed = parseInt(value, 10);
        return isNaN(parsed) ? fallback : parsed;
      }

      function pad(value) {
        return String(Math.max(0, value)).padStart(2, '0');
      }

      function to24Hour(hour12, period) {
        if (period === 'am') {
          return hour12 === 12 ? 0 : hour12;
        }
        return hour12 === 12 ? 12 : hour12 + 12;
      }

      function readConfig() {
        var elements = getTimerElements();
        if (!elements.timer) return null;

        return {
          resetMode: elements.timer.getAttribute('data-reset-mode') || 'refresh_reset',
          durationHours: toInt(elements.timer.getAttribute('data-duration-hours'), 2),
          durationMinutes: toInt(elements.timer.getAttribute('data-duration-minutes'), 0),
          durationSeconds: toInt(elements.timer.getAttribute('data-duration-seconds'), 0),
          dailyHour: toInt(elements.timer.getAttribute('data-daily-hour'), 9),
          dailyMinute: toInt(elements.timer.getAttribute('data-daily-minute'), 0),
          dailyPeriod: (elements.timer.getAttribute('data-daily-period') || 'pm').toLowerCase()
        };
      }

      function getDurationEndTime(config) {
        var durationMs = ((((config.durationHours * 60) + config.durationMinutes) * 60) + config.durationSeconds) * 1000;
        return Date.now() + durationMs;
      }

      function getDailyEndTime(config) {
        var now = new Date();
        var next = new Date(now);
        var hour24 = to24Hour(config.dailyHour, config.dailyPeriod);

        next.setHours(hour24, config.dailyMinute, 0, 0);

        if (next.getTime() <= now.getTime()) {
          next.setDate(next.getDate() + 1);
        }

        return next.getTime();
      }

      function render(diffMs) {
        var elements = getTimerElements();
        if (!elements.hours || !elements.minutes || !elements.seconds) return;

        var totalSeconds = Math.max(0, Math.floor(diffMs / 1000));
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        elements.hours.textContent = pad(hours);
        elements.minutes.textContent = pad(minutes);
        elements.seconds.textContent = pad(seconds);
      }

      function destroyExistingTimer() {
        var existing = window.CountdownBannerTimers[sectionId];
        if (!existing) return;

        if (existing.intervalId) {
          clearInterval(existing.intervalId);
        }

        if (existing.sectionLoadHandler) {
          document.removeEventListener('shopify:section:load', existing.sectionLoadHandler);
        }

        if (existing.sectionSelectHandler) {
          document.removeEventListener('shopify:section:select', existing.sectionSelectHandler);
        }

        if (existing.visibilityHandler) {
          document.removeEventListener('visibilitychange', existing.visibilityHandler);
        }

        delete window.CountdownBannerTimers[sectionId];
      }

      function initTimer() {
        destroyExistingTimer();

        var config = readConfig();
        if (!config) return;

        var endTime = config.resetMode === 'daily_reset_time'
          ? getDailyEndTime(config)
          : getDurationEndTime(config);

        function tick() {
          var latestConfig = readConfig();
          if (!latestConfig) return;

          config = latestConfig;

          if (config.resetMode === 'daily_reset_time') {
            endTime = getDailyEndTime(config);
            render(endTime - Date.now());
            return;
          }

          var diffMs = endTime - Date.now();

          if (diffMs <= 0) {
            diffMs = 0;
            clearInterval(intervalId);
          }

          render(diffMs);
        }

        function sectionLoadHandler(event) {
          if (!event || !event.detail || event.detail.sectionId !== sectionId) return;
          initTimer();
        }

        function sectionSelectHandler(event) {
          if (!event || !event.detail || event.detail.sectionId !== sectionId) return;
          initTimer();
        }

        function visibilityHandler() {
          if (document.hidden) return;
          initTimer();
        }

        tick();
        var intervalId = setInterval(tick, 1000);

        document.addEventListener('shopify:section:load', sectionLoadHandler);
        document.addEventListener('shopify:section:select', sectionSelectHandler);
        document.addEventListener('visibilitychange', visibilityHandler);

        window.CountdownBannerTimers[sectionId] = {
          intervalId: intervalId,
          sectionLoadHandler: sectionLoadHandler,
          sectionSelectHandler: sectionSelectHandler,
          visibilityHandler: visibilityHandler
        };
      }

      initTimer();
    })();
  

  (function () {
    var section = document.getElementById('shopify-section-sections--20177149853835__new_homepage_header_4gW9Bm');
    if (!section || section.dataset.lrInitialized) return; section.dataset.lrInitialized='true';
    var header = section.querySelector('.custom_header_hk');
    if (!header) return;

    var SETTLE_AT = 4; // px tolerance for rubber banding / sub pixel scroll
    var ticking = false;

    function apply() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y <= SETTLE_AT) {
        header.classList.add('is-settled');
      } else {
        header.classList.remove('is-settled');
      }
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }

    // Paint the correct state on the very first frame, then enable transitions.
    apply();
    window.requestAnimationFrame(function () {
      header.classList.add('hdr-ready');
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('orientationchange', onScroll);
    window.addEventListener('load', apply);
    window.addEventListener('pageshow', apply);
    document.addEventListener('shopify:section:load', apply);
  })();


  (function () {
    var root = document.getElementById('TrustTicker--template--20177151033483__lymphoria_ticker_qbz_qe3Xkt');
    if (!root) return;

    var track = root.querySelector('.tt__track');
    var pxPerSecond = parseFloat(root.dataset.speed) || 60;

    function setDuration() {
      var half = track.scrollWidth / 2;
      if (!half) return;
      track.style.setProperty('--tt-duration', (half / pxPerSecond).toFixed(2) + 's');
    }

    setDuration();

    if ('ResizeObserver' in window) {
      new ResizeObserver(setDuration).observe(root);
    } else {
      window.addEventListener('resize', setDuration);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setDuration);
    }
  })();


  (function () {
    var root = document.getElementById('lw-inside-template--20177151033483__lymphoria_whats_inside_wbz_r6PnFY');
    if (!root || root.dataset.lwReady === 'true') return;
    root.dataset.lwReady = 'true';

    var circles = Array.prototype.slice.call(root.querySelectorAll('[data-lw-circle]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-lw-panel]'));

    function setActive(index) {
      circles.forEach(function (circle, i) {
        var on = i === index;
        circle.classList.toggle('is-active', on);
        circle.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      panels.forEach(function (panel, i) {
        panel.hidden = i !== index;
      });
    }

    circles.forEach(function (circle, i) {
      circle.addEventListener('click', function (event) {
        event.stopPropagation();
        setActive(circle.classList.contains('is-active') ? -1 : i);
      });
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) setActive(-1);
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setActive(-1);
    });
  })();


  (() => {
    const section = document.querySelector('[data-routine-section]');
    if (!section || section.dataset.lrInitialized) return; section.dataset.lrInitialized='true';

    const grid = section.querySelector('[data-routine-grid]');
    const toggle = section.querySelector('[data-routine-toggle]');
    if (!grid || !toggle) return;

    const cards = Array.from(grid.querySelectorAll('.routine-testimonials__card'));
    const mobileMq = window.matchMedia('(max-width: 749px)');
    const desktopInitial = Number(grid.dataset.desktopInitial || 6);
    const mobileInitial = Number(grid.dataset.mobileInitial || 3);
    const showMoreLabel = toggle.dataset.showMoreLabel || 'Show More';
    const showLessLabel = toggle.dataset.showLessLabel || 'Show Less';

    let expandedDesktop = false;
    let expandedMobile = false;

    const applyVisibility = () => {
      const isMobile = mobileMq.matches;
      const limit = isMobile ? mobileInitial : desktopInitial;
      const expanded = isMobile ? expandedMobile : expandedDesktop;

      cards.forEach((card, index) => {
        card.classList.remove('is-revealed-desktop', 'is-revealed-mobile');

        if (isMobile) {
          if (index >= mobileInitial && expanded) {
            card.classList.add('is-revealed-mobile');
          }
        } else {
          if (index >= desktopInitial && expanded) {
            card.classList.add('is-revealed-desktop');
          }
        }
      });

      const needsToggle = cards.length > limit;
      toggle.hidden = !needsToggle;

      if (needsToggle) {
        toggle.textContent = expanded ? showLessLabel : showMoreLabel;
      }
    };

    toggle.addEventListener('click', () => {
      if (mobileMq.matches) {
        expandedMobile = !expandedMobile;
      } else {
        expandedDesktop = !expandedDesktop;
      }

      applyVisibility();
    });

    const handleResize = () => {
      applyVisibility();
    };

    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', handleResize);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(handleResize);
    }

    applyVisibility();
  })();


  (function () {
    var root = document.getElementById('lw-pdp-template--20177151033483__lymphoria_home_buy_box_wbz_RwVcQY');
    if (!root || root.dataset.lwReady === 'true') return;
    root.dataset.lwReady = 'true';

    var BSEP = "~|~";

    /* ---------- gallery (swiper) ---------- */
    var mainEl = root.querySelector('[data-lw-main]');
    var thumbsEl = root.querySelector('[data-lw-thumbs]');
    var prevEl = root.querySelector('[data-lw-prev]');
    var nextEl = root.querySelector('[data-lw-next]');
    var mainSwiper = null;
    var thumbsSwiper = null;

    function buildGallery() {
      if (!mainEl) return;

      var slideCount = mainEl.querySelectorAll('.swiper-slide').length;
      if (slideCount < 2) return;

      /*
        Loop mode clones slides, so it needs a little room to work with.
        Three or more images rotate endlessly in whichever direction the
        shopper is heading. With exactly two, cloning gets jumpy, so those
        fall back to rewind, which still wraps around, just without the
        continuous slide.
      */
      var useLoop = slideCount > 2;

      if (thumbsEl) {
        thumbsSwiper = new Swiper(thumbsEl, {
          a11y: { enabled: false },
          slidesPerView: 4,
          spaceBetween: 10,
          freeMode: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          centerInsufficientSlides: true,
          watchOverflow: true,
          breakpoints: {
            600: { spaceBetween: 16,
            slidesPerView: 5 },
            900: { spaceBetween: 24,
            slidesPerView: 6  }
          }
        });
      }

      mainSwiper = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: useLoop,
        loopAdditionalSlides: 2,
        rewind: !useLoop,
        speed: 350,
        grabCursor: true,
        watchOverflow: true,
        keyboard: { enabled: true, onlyInViewport: true },
        navigation: (prevEl && nextEl) ? { prevEl: prevEl, nextEl: nextEl } : false,
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper, autoScrollOffset: 1 } : undefined,
        a11y: {
          prevSlideMessage: 'Previous image',
          nextSlideMessage: 'Next image'
        }
      });

      /*
        In loop mode Swiper drives the thumbs off realIndex, but the strip
        itself does not always scroll far enough to keep the active thumb on
        screen once the main stage has wrapped. Nudge it after every change.
      */
      if (useLoop && thumbsSwiper) {
        mainSwiper.on('slideChange', function () {
          thumbsSwiper.slideTo(mainSwiper.realIndex, 300);
        });
      }
    }

    /* the Swiper bundle is deferred, so wait for it before booting */
    (function waitForSwiper(tries) {
      tries = tries || 0;
      if (window.Swiper) { buildGallery(); return; }
      if (tries > 240) return; /* give up after ~6s, static first frame stays */
      setTimeout(function () { waitForSwiper(tries + 1); }, 25);
    })();

    /* tear down cleanly when the theme editor swaps the section */
    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.target || event.target.id !== 'shopify-section-template--20177151033483__lymphoria_home_buy_box_wbz_RwVcQY') return;
      if (mainSwiper) { mainSwiper.destroy(true, true); mainSwiper = null; }
      if (thumbsSwiper) { thumbsSwiper.destroy(true, true); thumbsSwiper = null; }
    });


})();

  (function () {
    var root = document.getElementById('lw-faq-template--20177151033483__lymphoria_faq_cta_wbz_Vrd8gC');
    if (!root || root.dataset.lwReady === 'true') return;
    root.dataset.lwReady = 'true';

    var singleOpen = true;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-lw-item]'));

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var btn = item.querySelector('[data-lw-toggle]');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    items.forEach(function (item) {
      var btn = item.querySelector('[data-lw-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        if (singleOpen) {
          items.forEach(function (other) {
            if (other !== item) setOpen(other, false);
          });
        }
        setOpen(item, willOpen);
      });
    });
  })();

}
initializeReference();
document.addEventListener("shopify:section:load",initializeReference);
